/**
 * 脱敏手机号
 * 例如: 13812345678 => 138****5678
 */
export function maskPhone(phone: string): string {
  if (!phone) return '';
  // 只处理11位手机号
  if (/^\d{11}$/.test(phone)) {
    return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
  }
  // 其他长度简单处理
  if (phone.length > 7) {
    return phone.slice(0, 3) + '****' + phone.slice(-4);
  }
  return phone;
}

/**
 * 脱敏邮箱
 * 例如: jia1234@gmail.com => jia****@gmail.com
 */
export function maskEmail(email: string): string {
  if (!email) return '';
  const [name, domain] = email.split('@');
  if (!name || !domain) return email;
  if (name.length <= 3) {
    return name[0] + '****@' + domain;
  }
  return name.slice(0, 3) + '****@' + domain;
}

/**
 * 通用倒计时工具
 * @param countdown 当前倒计时数值
 * @param setCountdown 设置倒计时的 setState 函数
 * @param options 可选项: interval(间隔, 默认1000ms), onEnd(倒计时结束回调)
 */
export function startCountdown(
  countdown: number,
  setCountdown: (n: number) => void,
  options?: { interval?: number; onEnd?: () => void; }
) {
  const interval = options?.interval ?? 1000;
  let timer: ReturnType<typeof setInterval> | null = null;
  let current = countdown;

  function tick() {
    current -= 1;
    setCountdown(current);
    if (current <= 0) {
      if (timer) clearInterval(timer);
      if (options?.onEnd) options.onEnd();
    }
  }

  // 立即执行一次
  setCountdown(current);
  if (current > 0) {
    timer = setInterval(tick, interval);
  } else {
    if (options?.onEnd) options.onEnd();
  }

  // 返回清理函数
  return () => {
    if (timer) clearInterval(timer);
  };
}

export const optionList2Map = (list: { value: string; label: string; }[]) => {
  const map = {};
  list.forEach(item => {
    map[item.value] = item.label;
  });
  return map;
};

export const isLargeNumberString = (value: number) => {
  return value.toString().length > 10 || value >= 100000000;
};